import name from './name'
import { createSlice } from '@reduxjs/toolkit'

const initialState = {
  trialBannerDismissed: false
}

const trial = createSlice({
  name,
  initialState,
  reducers: {
    dismissTrialBanner: (state) => {
      state.trialBannerDismissed = true
    },
    resetTrialBannerDismissal: (state) => {
      state.trialBannerDismissed = false
    }
  }
})

export const { dismissTrialBanner, resetTrialBannerDismissal } = trial.actions

export default trial.reducer
